import React from 'react'
import { useState, useEffect } from 'react'

function useIntersection(ref, rootMargin = "-150px") {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    ref.current.className = ref.current.className + " invisible"
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntersecting(true);
          observer.unobserve(ref.current);
        }
      },
      { rootMargin,}
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.unobserve(ref.current);
  }, []);
  if (isIntersecting) {
    ref.current.className = ref.current.className.replace("invisible", "animateOnScreen")
  }
}

export default useIntersection